<template>
  <div
    class="d-flex flex-column h-100 w-100"
    style="text-align: -webkit-center; position: relative"
  >
    <div
      class="d-flex flex-column h-100 w-100"
      style="max-width: 1300px"
    >
      <div class="mb-2">
        <div class="scores-status">Chemicals: {{ selected.length }}/{{ hazardReport.length }}</div>
        <HazardLegend />
      </div>

      <div
        class="d-flex flex-column flex-grow-1 h-100 overflow-auto w-100"
        style="min-height: 0"
      >
        <table class="table table-bordered table-records mb-0">
          <thead class="table-secondary fixed-table-header">
            <tr>
              <th
                rowspan="3"
                class="text-left"
              >
                <div class="d-flex flex-column align-items-start gap-4">
                  <div>
                    <v-checkbox
                      v-model="showSkippedChemicals"
                      :disabled="!report.skippedChemicals.length"
                      title="Show/Hide Skipped Chemicals"
                      :label="`Skipped (${report.skippedChemicals.length})`"
                      hide-details
                      dense
                    />

                    <v-checkbox
                      v-model="showUnlikely"
                      :disabled="!unlikelyMetabolites.length"
                      title="Show/Hide UNLIKELY metabolites"
                      :label="`Unlikely (${unlikelyMetabolites.length})`"
                      hide-details
                      dense
                    />

                    <v-checkbox
                      v-model="showAddFilter"
                      switches
                      title="Show/Hide Filters"
                      :label="`Filters (${getAddedFilters.length})`"
                      hide-details
                      dense
                    />

                    <v-checkbox
                      v-model="showSorting"
                      :disabled="!getHazardSortBy.length"
                      switches
                      title="Show/Hide Sorting"
                      :label="`Sorting (${getHazardSortBy.length})`"
                      hide-details
                      dense
                    />

                    <!-- <b-form-checkbox
                      v-model="showSkippedChemicals"
                      :disabled="!report.skippedChemicals.length"
                      switches
                      title="Show/Hide Skipped Chemicals"
                    >
                      Skipped ({{ report.skippedChemicals.length }})
                    </b-form-checkbox>

                    <b-form-checkbox
                      v-model="showUnlikely"
                      :disabled="!unlikelyMetabolites.length"
                      switches
                      title="Show/Hide UNLIKELY metabolites"
                    >
                      Unlikely ({{ unlikelyMetabolites.length }})
                    </b-form-checkbox>

                    <b-form-checkbox
                      v-model="showAddFilter"
                      switches
                      title="Show/Hide filters"
                    >
                      Filters ({{ getAddedFilters.length }})
                    </b-form-checkbox>

                    <b-form-checkbox
                      v-model="showSorting"
                      :disabled="!getHazardSortBy.length"
                      switches
                      title="Show/Hide sorting"
                    >
                      Sorting ({{ getHazardSortBy?.length }})
                    </b-form-checkbox> -->
                  </div>

                  <span class="ml-1">Name / CAS</span>
                </div>
              </th>

              <!-- categories I -->
              <th
                v-if="isVisibleColumn('humanHealthEffects')"
                :colspan="getColSpan('humanHealthEffects')"
              >
                <span>Human Health Effects</span>
              </th>

              <th
                v-if="isVisibleColumn('ecotoxicity')"
                :colspan="getColSpan('ecotoxicity')"
              >
                <span>Ecotoxicity</span>
              </th>

              <th
                v-if="isVisibleColumn('fate')"
                :colspan="getColSpan('fate')"
              >
                <span>Fate</span>
              </th>
            </tr>

            <!-- categories II -->
            <tr>
              <th
                v-if="isVisibleColumn('acuteMammalian')"
                :colspan="getColSpan('acuteMammalian')"
              >
                <span>Acute Mammalian Toxicity</span>
              </th>
              <HazardHeader
                v-if="isVisibleColumn('carcinogenicity')"
                :header-click="onHazardHeaderClick('carcinogenicity')"
                hazard-id="carcinogenicity"
                rowspan="2"
              />
              <HazardHeader
                v-if="isVisibleColumn('genotoxicity')"
                :header-click="onHazardHeaderClick('genotoxicity')"
                hazard-id="genotoxicity"
                rowspan="2"
              />
              <HazardHeader
                v-if="isVisibleColumn('endocrine')"
                :header-click="onHazardHeaderClick('endocrine')"
                hazard-id="endocrine"
                rowspan="2"
              />
              <HazardHeader
                v-if="isVisibleColumn('reproductive')"
                :header-click="onHazardHeaderClick('reproductive')"
                hazard-id="reproductive"
                rowspan="2"
              />
              <HazardHeader
                v-if="isVisibleColumn('developmental')"
                :header-click="onHazardHeaderClick('developmental')"
                hazard-id="developmental"
                rowspan="2"
              />
              <th
                v-if="isVisibleColumn('neurotoxicity')"
                :colspan="getColSpan('neurotoxicity')"
              >
                <span>Neurotoxicity</span>
              </th>
              <th
                v-if="isVisibleColumn('systemicToxicity')"
                :colspan="getColSpan('systemicToxicity')"
              >
                <span>Systemic Toxicity</span>
              </th>
              <HazardHeader
                v-if="isVisibleColumn('skinSensitization')"
                :header-click="onHazardHeaderClick('skinSensitization')"
                hazard-id="skinSensitization"
                rowspan="2"
              />
              <HazardHeader
                v-if="isVisibleColumn('skinIrritation')"
                :header-click="onHazardHeaderClick('skinIrritation')"
                hazard-id="skinIrritation"
                rowspan="2"
              />
              <HazardHeader
                v-if="isVisibleColumn('eyeIrritation')"
                :header-click="onHazardHeaderClick('eyeIrritation')"
                hazard-id="eyeIrritation"
                rowspan="2"
              />

              <HazardHeader
                v-if="isVisibleColumn('acuteAquatic')"
                :header-click="onHazardHeaderClick('acuteAquatic')"
                hazard-id="acuteAquatic"
                rowspan="2"
              />
              <HazardHeader
                v-if="isVisibleColumn('chronicAquatic')"
                :header-click="onHazardHeaderClick('chronicAquatic')"
                hazard-id="chronicAquatic"
                rowspan="2"
              />
              <HazardHeader
                v-if="isVisibleColumn('persistence')"
                :header-click="onHazardHeaderClick('persistence')"
                hazard-id="persistence"
                rowspan="2"
              />
              <HazardHeader
                v-if="isVisibleColumn('bioaccumulation')"
                :header-click="onHazardHeaderClick('bioaccumulation')"
                hazard-id="bioaccumulation"
                rowspan="2"
              />

              <HazardHeader
                v-if="isVisibleColumn('exposure')"
                :header-click="onHazardHeaderClick('exposure')"
                hazard-id="exposure"
                rowspan="2"
              />
            </tr>

            <!-- endpoints -->
            <tr>
              <HazardHeader
                v-if="isVisibleColumn('acuteMammalianOral')"
                :header-click="onHazardHeaderClick('acuteMammalianOral')"
                column-name="Oral"
                hazard-id="acuteMammalianOral"
              />
              <HazardHeader
                v-if="isVisibleColumn('acuteMammalianInhalation')"
                :header-click="onHazardHeaderClick('acuteMammalianInhalation')"
                column-name="Inhalation"
                hazard-id="acuteMammalianInhalation"
              />
              <HazardHeader
                v-if="isVisibleColumn('acuteMammalianDermal')"
                :header-click="onHazardHeaderClick('acuteMammalianDermal')"
                column-name="Dermal"
                hazard-id="acuteMammalianDermal"
              />
              <HazardHeader
                v-if="isVisibleColumn('neurotoxicityRepeat')"
                :header-click="onHazardHeaderClick('neurotoxicityRepeat')"
                column-name="Repeat Exposure"
                hazard-id="neurotoxicityRepeat"
              />
              <HazardHeader
                v-if="isVisibleColumn('neurotoxicitySingle')"
                :header-click="onHazardHeaderClick('neurotoxicitySingle')"
                column-name="Single Exposure"
                hazard-id="neurotoxicitySingle"
              />
              <HazardHeader
                v-if="isVisibleColumn('systemicToxicityRepeat')"
                :header-click="onHazardHeaderClick('systemicToxicityRepeat')"
                column-name="Repeat Exposure"
                hazard-id="systemicToxicityRepeat"
              />
              <HazardHeader
                v-if="isVisibleColumn('systemicToxicitySingle')"
                :header-click="onHazardHeaderClick('systemicToxicitySingle')"
                column-name="Single Exposure"
                hazard-id="systemicToxicitySingle"
              />
            </tr>
          </thead>

          <tbody class="overflow-auto">
            <tr v-show="showSkippedChemicals && report.skippedChemicals.length">
              <td class="row-pseudo-title">Skipped Chemicals</td>
              <td :colspan="report.hazardChemicals[0] ? report.hazardChemicals[0].scores.length : 1">
                <b-container size="sm">
                  <b-row
                    v-if="report.skippedChemicals.length"
                    size="sm"
                  >
                    <b-col
                      v-for="item in report.skippedChemicals"
                      :key="item.id"
                      class="m-2 p-0"
                      cols="auto"
                    >
                      <ChemCard
                        :item="item"
                        :on-zoom-click="onOpenLarge"
                      />
                    </b-col>
                  </b-row>
                </b-container>
              </td>
            </tr>

            <tr v-show="showSorting && getHazardSortBy?.length">
              <td class="row-pseudo-title">Sorting</td>
              <td :colspan="report.hazardChemicals[0] ? report.hazardChemicals[0].scores.length : 1">
                <b-container size="sm">
                  <b-row
                    v-if="getHazardSortBy.length"
                    align-v="center"
                    size="sm"
                  >
                    <b-col class="col-5 text-left">
                      <div
                        v-for="s in getHazardSortBy"
                        :key="`sk=${s[0]}`"
                      >
                        {{ getEndpointNameById(s[0]) }}
                        <b-icon
                          :icon="s[1] ? 'arrow-up-right' : 'arrow-down-right'"
                          class="help"
                        />
                        <b-button-close @click="removeSorting(`${s[0]}`)" />
                      </div>
                    </b-col>
                    <b-col class="col" />
                    <b-col class="col-1 pr-1">
                      <b-button
                        class="right"
                        size="sm"
                        @click="resetSorting"
                      >
                        Reset
                      </b-button>
                    </b-col>
                  </b-row>
                </b-container>
              </td>
            </tr>

            <tr v-show="getAddedFilters.length">
              <td class="row-pseudo-title">Filters</td>
              <td :colspan="report.hazardChemicals[0] ? report.hazardChemicals[0].scores.length : 1">
                <b-container size="sm">
                  <b-row
                    v-if="getAddedFilters.length"
                    align-v="center"
                  >
                    <b-col class="text-left">
                      <div
                        v-for="f in getAddedFilters"
                        :key="`f-${f[3]}`"
                      >
                        {{ getEndpointNameById(f[0]) }} I: {{ f[1] }}, X:
                        {{ f[2] }}
                        <b-button-close @click="removeFilter(`${f[3]}`)" />
                      </div>
                    </b-col>
                    <b-col class="col-1 pr-1">
                      <b-button
                        class="right"
                        size="sm"
                        @click="resetFilters"
                      >
                        Reset
                      </b-button>
                    </b-col>
                  </b-row>
                </b-container>
              </td>
            </tr>

            <tr v-if="showAddFilter">
              <td class="row-pseudo-title">Add Filter(s)</td>
              <td :colspan="report.hazardChemicals[0] ? report.hazardChemicals[0].scores.length : 1">
                <b-container size="sm">
                  <b-row>
                    <b-col class="col px-1 text-left">
                      Include chemicals having at least one of:
                      <b-form-checkbox-group
                        v-model="filterInclude"
                        :options="options"
                        size="sm"
                        @change="filterIncludeChanged"
                      />
                    </b-col>

                    <b-col class="col px-1 text-left">
                      Exclude chemicals having any of:
                      <b-form-checkbox-group
                        v-model="filterExclude"
                        :options="options"
                        size="sm"
                        @change="filterExcludeChanged"
                      />
                    </b-col>

                    <b-col class="col-2 px-1">
                      <b-form-select
                        v-model="filterEndpoint"
                        :options="
                          report.hazardChemicals[0].scores.map((s) => ({
                            value: s.hazardId,
                            text: s.hazardName,
                          }))
                        "
                        size="sm"
                      >
                        <b-form-select-option :value="null">Any Hazard Endpoint</b-form-select-option>
                      </b-form-select>
                    </b-col>
                    <b-col class="col-1 pr-1">
                      <b-button
                        class="right"
                        size="sm"
                        @click="addFilter"
                      >
                        Add
                      </b-button>
                    </b-col>
                  </b-row>
                </b-container>
              </td>
            </tr>

            <!-- eslint-disable-next-line vue/no-v-for-template-key-on-child, vue/no-v-for-template-key -->
            <template v-for="(hazardChemical, chemical_index) in pageRecords">
              <tr
                :key="`c-${hazardChemical.chemical.chemId}`"
                :class="{
                  'product-chemical': 'derived' in hazardChemical.requestChemical.properties,
                }"
              >
                <td>
                  <ChemCell
                    :chemical="hazardChemical.chemical"
                    :request-chemical="hazardChemical.requestChemical"
                    :show-images="showImages"
                    :show-checkbox="!!onCheckClick"
                    @check-click="onCheckClick"
                    @similarity-click="onHazardHeaderClick('similarity')()"
                    :show-similarity-sorting-icon="true"
                  />
                </td>

                <template v-for="(score, cat_index) in hazardChemical.scores">
                  <td
                    v-if="isVisibleColumn(score.hazardId)"
                    :id="`h-${hazardChemical.chemical.chemId}-${score.hazardId}`"
                    :key="`h-${hazardChemical.chemical.chemId}-${score.hazardId}`"
                    :class="{
                      'table-td-hover': score && score.records.length > 0,
                      'table-secondary': score && score.finalScore === 'I',
                      'table-warning-light': score && score.finalScore === 'M',
                      'table-success': score && score.finalScore === 'L',
                      'table-danger': score && score.finalScore === 'VH',
                      'table-orange': score && score.finalScore === 'H',
                      'active': chemical_index === chemIndex && cat_index === catIndex,
                      'authoritative': score && score.finalAuthority === 'Authoritative',
                      'screening': score && score.finalAuthority === 'Screening',
                      'predicted': score && score.finalAuthority === 'QSAR Model',
                    }"
                    @click="
                      score && score.records.length > 0
                        ? showScoreRecordsTable(hazardChemical.chemical, score, chemical_index, null, cat_index)
                        : null
                    "
                  >
                    {{ !score || score.finalScore === 'ND' ? '' : score.finalScore }}
                    <HazardPopover
                      v-if="score && score.finalScore !== 'ND'"
                      :delay="1000"
                      :hazard-category="score.hazardId"
                      :hazard-chemical="hazardChemical"
                      :target="`h-${hazardChemical.chemical.id}-${score.hazardId}`"
                      first-only
                    />
                  </td>
                </template>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="flex-grow-1" />
      </div>

      <v-row class="d-flex flex-grow-0 justify-end gap-2 ma-2 align-items-center">
        <div class="d-flex gap-1 align-baseline">
          <span>Show</span>
          <v-select
            v-model="pageSize"
            :items="[10, 30, 50, 100]"
            style="max-width: 5em"
            dense
            hide-details
          />
          <span>per page</span>
        </div>

        <v-pagination
          v-if="hazardReport.length > pageSize"
          v-model="page"
          :length="Math.floor(hazardReport.length / pageSize) + 1"
          :total-visible="7"
          class="mt-2"
        />
      </v-row>

      <ScoreRecordsModal
        v-model="showRecords"
        :hazard-name="hazardName"
        :score-records="scoreRecords"
        :chemical="scoreStructure"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { eventBus, getStructureImageUrl } from '@/main'
import HazardLegend from './HazardLegend.vue'
import HazardHeader from './HazardHeader.vue'
import ChemCell from '@/components/chemical/ChemCell.vue'
import ChemCard from '@/components/chemical/ChemCard.vue'
import hash from 'object-hash'
import HazardPopover from './HazardPopover.vue'
import ScoreRecordsModal from '@/components/hazard/ScoreRecordsModal'
import { hazardReportFilteredOrdered } from '@/store/hazard'

function hasAscendant(cid, ascendantCatId, catsDefinitions) {
  const cat = catsDefinitions.find((c) => c.id === cid)
  if (!Object.prototype.hasOwnProperty.call(cat, 'parentId')) return false

  return cat.parentId === ascendantCatId || hasAscendant(cat.parentId, ascendantCatId, catsDefinitions)
}

function isCatIdInProfile(catId, profileCatIds, catsDefinitions) {
  return (
    profileCatIds.find(
      (profileCatId) => profileCatId === catId || hasAscendant(catId, profileCatId, catsDefinitions),
    ) != null
  )
}

function hasProfileCategory(catId, profileCatIds, catsDefinitions) {
  return profileCatIds.find((cid) => cid === catId || hasAscendant(cid, catId, catsDefinitions)) != null
}

export default {
  components: {
    ScoreRecordsModal,
    HazardPopover,
    ChemCell,
    ChemCard,
    HazardHeader,
    HazardLegend,
  },

  props: {
    report: {
      type: Object,
      required: true,
    },
    reportFilters: {
      type: Object,
      required: true,
    },
    showImages: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Array,
      required: true,
    },
    onCheckClick: {
      type: Function,
      default: undefined,
    },
  },

  data() {
    return {
      showSkippedChemicals: false,
      showUnlikely: false,
      showSorting: true,
      showAddFilter: false,
      filterEndpoint: null,
      filterInclude: ['VH', 'H', 'M', 'L', 'I', 'ND'],
      filterExclude: [],
      options: [
        { text: 'VH', value: 'VH' },
        { text: 'H', value: 'H' },
        { text: 'M', value: 'M' },
        { text: 'L', value: 'L' },
        { text: 'I', value: 'I' },
        { text: 'ND', value: 'ND' },
      ],
      chemIndex: null,
      chemProd: null,
      catIndex: null,
      scoreStructure: null,
      hazardName: null,
      scoreRecords: null,
      showRecords: false,
      scoreRecordFields: [
        { key: 'source', sortable: true },
        { key: 'authority', sortable: true },
        { key: 'score', sortable: true },
        { key: 'route', sortable: true },
        { key: 'category', sortable: true },
        { key: 'hazardCode', sortable: true },
        { key: 'hazardStatement' },
        { key: 'rationale' },
        { key: 'note' },
      ],
      page: 1,
      pageSize: 50,
    }
  },

  watch: {
    pageSize() {
      this.page = Math.min(this.page, Math.floor(this.hazardReport.length / this.pageSize) + 1)
    },
    showUnlikely() {
      this.$emit('showUnlikely-changed', this.showUnlikely)
      this.$emit('onFilterAdded')
    },
  },

  computed: {
    ...mapGetters([
      'getHazardCategories',
      'getHazardProfiles',
      'getHazardEndpoints',
      'getHazardSortBy',
      'getAddedFilters',
    ]),
    pageRecords() {
      return this.hazardReport.slice((this.page - 1) * this.pageSize, this.page * this.pageSize)
    },
    unlikelyMetabolites() {
      return this.report.hazardChemicals.filter(
        (r) =>
          'ctsChemical' in r.requestChemical.properties &&
          r.requestChemical.properties.ctsChemical.likelihood === 'UNLIKELY',
      )
    },
    hazardProfile() {
      if (this.reportFilters.profile == null) return null
      if (this.reportFilters.profile === 'custom') return { categories: this.reportFilters.customProfile }
      return this.getHazardProfiles.find((p) => p.id === this.reportFilters.profile)
    },
    filters() {
      return this.getAddedFilters /*.concat([[this.filterEndpoint, this.filterInclude, this.filterExclude]])*/
    },
    hazardReport() {
      return hazardReportFilteredOrdered(this.report, this.filters, this.getHazardSortBy, this.showUnlikely)
      /*function compareHazardScores(sort_by) {
        const scoreWeights = {VH: 4, H: 3, M: 2, L: 1};
        const authorityWeights = {Authoritative: 3, Screening: 2, 'QSAR Model': 1};
        return function (a, b) {
          if (!sort_by[0]) return 0;

          let cmp = 0;
          for (const srt of sort_by) {
            const scoreA = a.scores.filter((s) => s.hazardId === srt[0])[0];
            const scoreB = b.scores.filter((s) => s.hazardId === srt[0])[0];

            const swA = scoreWeights[scoreA.finalScore] || 0;
            const swB = scoreWeights[scoreB.finalScore] || 0;

            const awA = authorityWeights[scoreA.finalAuthority] || 0;
            const awB = authorityWeights[scoreB.finalAuthority] || 0;

            cmp = swA - swB;
            cmp = srt[1] ? cmp : cmp * -1;
            if (cmp) break;

            cmp = awA - awB;
            cmp = srt[1] ? cmp : cmp * -1;
            if (cmp) break;
          }

          return cmp;
        };
      }

      // Filter out UNLIKELY if any
      let filtered = this.report.hazardChemicals.filter(
        (r) =>
          this.showUnlikely ||
          !('ctsChemical' in r.requestChemical.properties) ||
          r.requestChemical.properties.ctsChemical.likelihood !== 'UNLIKELY',
      );

      if (this.filters[0]) {
        // "Include" filters
        filtered = filtered.filter((c) => {
          for (const f of this.filters) {
            for (const s of c.scores) {
              if ((!f[0] || s.hazardId === f[0]) && f[1].includes(s.finalScore)) return true;
            }
          }
          return false;
        });

        // "Exclude" filters
        filtered = filtered.filter((c) => {
          for (const f of this.filters) {
            for (const s of c.scores) {
              if ((!f[0] || s.hazardId === f[0]) && f[2].includes(s.finalScore)) return false;
            }
          }
          return true;
        });
      }

      return filtered.sort(compareHazardScores(this.getHazardSortBy));*/
    },
    allHazardCategories() {
      return this.getHazardCategories.concat(this.getHazardEndpoints)
    },
  },

  methods: {
    onHazardHeaderClick(hazardId) {
      let self = this
      return function () {
        let srt = self.getHazardSortBy.filter((s) => s[0] === hazardId)[0]
        if (!srt) self.getHazardSortBy.push([hazardId, false])
        else {
          srt[1] = !srt[1]
          self.$store.commit('SET_HAZARD_SORT_BY', [...self.getHazardSortBy])
        }
      }
    },

    resetSorting() {
      this.getHazardSortBy.splice(0, this.getHazardSortBy.length)
    },
    addFilter() {
      let filter = [this.filterEndpoint, this.filterInclude, this.filterExclude]
      const id = hash(filter)
      if (!this.getAddedFilters.find((f) => f[3] === id)) {
        filter.push(id)
        this.getAddedFilters.push(filter)
        this.filterInclude = ['VH', 'H', 'M', 'L', 'I', 'ND']
        this.filterExclude = []
        this.$emit('onFilterAdded')
      }
    },
    removeFilter(filterId) {
      const filterIndex = this.getAddedFilters.findIndex((f) => f[3] === filterId)
      if (filterIndex !== -1) this.getAddedFilters.splice(filterIndex, 1)
    },
    resetFilters() {
      this.filterInclude = ['VH', 'H', 'M', 'L', 'I', 'ND']
      this.filterExclude = []
      this.getAddedFilters.splice(0, this.getAddedFilters.length)
    },
    removeSorting(sortId) {
      const sortIndex = this.getHazardSortBy.findIndex((s) => s[0] === sortId)
      if (sortIndex !== -1) this.getHazardSortBy.splice(sortIndex, 1)
    },
    filterIncludeChanged: function (newFilter) {
      this.filterExclude = this.filterExclude.filter((f) => !newFilter.includes(f))
    },
    filterExcludeChanged: function (newFilter) {
      this.filterInclude = this.filterInclude.filter((f) => !newFilter.includes(f))
    },
    isVisibleColumn(catId) {
      return (
        this.hazardProfile == null ||
        isCatIdInProfile(catId, this.hazardProfile.categories, this.allHazardCategories) ||
        hasProfileCategory(catId, this.hazardProfile.categories, this.allHazardCategories)
      )
    },
    getColSpan(catId) {
      function countActiveDescendants(profileCatIds, catsDefinitions, endpoints) {
        let count = 0
        for (let cat of endpoints) {
          if (profileCatIds) {
            if (
              isCatIdInProfile(cat.id, profileCatIds, catsDefinitions) &&
              hasAscendant(cat.id, catId, catsDefinitions)
            )
              count++
          } else {
            if (hasAscendant(cat.id, catId, catsDefinitions)) count++
          }
        }
        return count
      }

      return countActiveDescendants(
        this.hazardProfile ? this.hazardProfile.categories : null,
        this.allHazardCategories,
        this.getHazardEndpoints,
      )
    },
    showScoreRecordsTable(chemical, score, chemIndex, prodIndex, catIndex) {
      this.scoreStructure = chemical
      this.hazardName = score.hazardName
      this.chemIndex = chemIndex
      this.prodIndex = prodIndex
      this.catIndex = catIndex
      this.scoreRecords = score.records
      this.showRecords = true
    },
    getStructureImageUrl(structure, width, height) {
      return getStructureImageUrl(structure, width, height)
    },
    onOpenLarge(smiles) {
      eventBus.$emit('SHOW_LARGE_IMG', smiles)
    },
    getEndpointNameById(fieldId) {
      if (fieldId === 'similarity') {
        return 'Similarity'
      }
      const endpoint = this.getHazardEndpoints.find((e) => e.id === fieldId)
      return endpoint ? endpoint.name : 'Any Hazard Endpoint'
    },
  },
}
</script>

<style scoped>
.scores-status {
  float: left;
  margin: 0.5em 0.2em 0.2em 0.2em;
}

.fixed-table-header {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 0;
  z-index: 2;
}

.v-input--selection-controls {
  margin-top: 0;
}

.product-chemical {
  background-color: rgba(255, 235, 205, 0.5);
}
</style>
